import { ReactNode } from 'react';
import { Badge, lucideIcons } from '@round/creatorbase-ui';
import styles from './TargetChips.module.css';

const { X } = lucideIcons;

export type TargetChip = {
    /** Stable across renders, and what `onRemove` hands back. */
    key: string;
    /** Plain text the chip stands for — the remove control's accessible name. */
    name: string;
    /** What the chip renders. Defaults to `name`, so a plain string chip needs nothing else. */
    label?: ReactNode;
};

type Props = {
    chips: TargetChip[];
    disabled?: boolean;
    onRemove: (key: string) => void;
};

/**
 * The chip list both target sections render into. It holds no opinion on what a target is — sounds
 * and hashtags agree only on being removable — so each section supplies its own chip body.
 */
export const TargetChips = ({ chips, disabled, onRemove }: Props) => {
    if (!chips.length) {
        return null;
    }

    return (
        <ul className={styles.chips}>
            {chips.map((chip) => (
                <li key={chip.key}>
                    <Badge variant="secondary" className={styles.chip}>
                        {chip.label ?? chip.name}

                        <button
                            type="button"
                            className={styles.remove}
                            disabled={disabled}
                            aria-label={`Remove ${chip.name}`}
                            onClick={() => onRemove(chip.key)}
                        >
                            <X />
                        </button>
                    </Badge>
                </li>
            ))}
        </ul>
    );
};
